import { PvInverterDto } from '../dto/pv-inverter.dto'
import { PvInverterModel } from '../models/solar.model'

const fromInverterDtoToModelTransformer = (dto: PvInverterDto): PvInverterModel => {
  return {
    moduleName: dto.moduleName,
    build: dto.BUILD?.[1],
    canInterface: dto.CAN_INTERFACE?.[1],
    canLoopback: dto.CAN_LOOPBACK?.[1],
    cosphi: dto.COSPHI?.[1],
    debug: dto.DEBUG?.[1],
    destinationAddress: dto.DEST_ADDRESS?.[1],
    devicePort: dto.DEVICE_PORT?.[1],
    e12EmergencyPowerDisabled: dto.E12EmergencyPowerDisabled?.[1],
    ipvMax1: dto.IPV_MAX1?.[1],
    ipvMax2: dto.IPV_MAX2?.[1],
    iDcMax1: dto.I_DC_MAX_1?.[1],
    iDcMax2: dto.I_DC_MAX_2?.[1],
    landNorm: dto.LANDNORM?.[1],
    picVersion: dto.PICVERSION?.[1],
    pw: dto.PW?.[1],
    silence: dto.SILENCE?.[1],
    serialnumber: dto.SN?.[1],
    serial: dto.SERIAL?.[1],
    stringCount: dto.STRINGCOUNT?.[1],
    type: dto.TYPE?.[1],
    uOFrequency: dto.UO_FREQ?.[1],
    uOFrequencyTestBsn: dto.UO_FREQ_TEST_BSN?.[1],
    uOFrequencyWhat: dto.UO_FREQ_WHAT?.[1],
    version: dto.VERSION?.[1],
    versionHw: dto.VERSION_HW?.[1],
    versionRcd1: dto.VERSION_RCD1?.[1],
    versionRcd2: dto.VERSION_RCD2?.[1],
    versionRel: dto.VERSION_REL?.[1],
    versionString: dto.VERSION_STRING?.[1],
    VersionUfg: dto.VERSION_UFG?.[1],
    vMonitor: dto.V_MONITOR?.[1],
  }
}

export default fromInverterDtoToModelTransformer
